$(document).ready(function () {  
    // $('.sub-menu-inner').hover(function (){
    //     $(this).find('.header__submenu').stop().slideToggle();
    //     $("body").toggleClass("menu-opened");
    // })
  
    $('.sub-menu-inner').mouseenter(function (evt){
        $(this).find('.header__submenu').stop().slideDown();
        $("body").toggleClass("menu-opened");
    })
    $('.sub-menu-inner').mouseleave(function (){
        $(this).find('.header__submenu').stop().slideUp();
        $("body").removeClass("menu-opened");
    })

    $('#sets').on('click', function(e) {
        e.preventDefault();
        $(this).closest('li').toggleClass('active');
        $(this).closest('li').find('ul').stop().slideToggle();
    })

    let ingredient_html = $(document).find('.product-ingredients-content').html();
    $('div#ingredients-container').html(ingredient_html);

    $('.product-new-tab-flex').find('.product-new-tab-trigger').each(function () {
        $(this).click(function() {
            let trigger_id = $(this).attr('id');
            if(!$(this).hasClass('active-tab')){
                $(this).addClass('active-tab').siblings().removeClass('active-tab');
                $('.product-new-tab-content-wrapper>div').each(function() {
                    let trigger_content = $(this).data('content');
                    if(trigger_id == trigger_content){
                        $(this).addClass('active-content').siblings().removeClass('active-content');
                        $(this).show();
                        $('html, body').animate({
                            scrollTop: $(this).offset().top - $('#shopify-section-header').height() - 70
                        }, 'smooth');
                    }else{
                        $(this).hide();
                    }
                })
            }
        })
    })

    $('button#product-ingredients-popup-close').click(function (e){
        e.preventDefault();
        $('body').css('overflow', 'auto');
        $('div#shopify-section-header').css('opacity', 1);
        $(document).find('.media-atc-main.is-fixed-mobile').css('opacity', 1);
        $('div#product-ingredients-popup').removeClass('show');
    })

    $('h3.product-directions-accordion-head').click(function(){
      if (!$(this).hasClass('first')){
        $(this).next('.product-directions-accordion-body').slideToggle();
        $(this).toggleClass('opened');
        $('.product-directions-accordion-body:not(.first)').not($(this).next()).slideUp();
        $('.product-directions-accordion-head:not(.first)').not($(this)).removeClass('opened');
      }
    })

    $('h3.product-faq-accordion-head').click(function(){
        $(this).next('.product-faq-accordion-body').slideToggle();
        $(this).toggleClass('opened');
        $('.product-faq-accordion-body').not($(this).next()).slideUp();
        $('.product-faq-accordion-head').not($(this)).removeClass('opened');
    })

    $('h4.new-faqs-tab-head').click(function(){
        $(this).next('.new-faqs-tab-body').slideToggle();
        $(this).toggleClass('opened');
        $('.new-faqs-tab-body').not($(this).next()).slideUp();
        $('.new-faqs-tab-head').not($(this)).removeClass('opened');
    })

    if($(document).find('.section-before-after-slider').length){
      var mySwiper = new Swiper ('.section-before-after-slider', {
          slidesPerView: 6,
          spaceBetween: 1,
          loop: true,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            0: {
              slidesPerView: 1.8,
              paginationClickable: true,
              centeredSlides: true,
              roundLengths: true,
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                  renderBullet: function (index, className) {
                    return `<span class="outer-dot swiper-pagination-bullet"><span class="inner-dot"></span></span>`;
                  }
              }
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 10,
            }
          }
      })
    }

    $('.short-desc-more').click(function(){
      // alert()
        $('.short-desc-info-mobl-less').show();
        $('.short-desc-info-mobl-more').hide();
    })

    $('.menu-drawer__inner-submenu .menu-drawer__close-button').on('click', function (){
        $(this).closest('details').prop('open', false);
    })

    let texts = [
        "<h3>The <strong>Breakouts</strong> Duo</h3>",    
        "<h3>The <strong>Blemish</strong> Duo</h3>",    
        "<h3>The <strong>Youth</strong> Duo</h3>",    
        "<h3>The <strong>Prevention</strong> Duo</h3>",    
        "<h3><strong>Barrier first,</strong></h3>",    
        "<h3>treatments second.</h3>"    
    ];
    
    var index = 0;

    function changeText() {
        $('.home-product-text-animation').html(texts[index]);
        index = (index + 1) % texts.length;
    }

    setInterval(changeText, 500);

      var popup = document.getElementById('popup-wrapper');
    if(popup != undefined){
      var btn = $(document).find("a[href='#priority-notification']");
      console.log(btn);
      var span = document.getElementById("close");
      btn.on('click', function(e) {
          e.preventDefault();
          popup.classList.add('show');
      })
      span.onclick = function() {
          popup.classList.remove('show');
      }
      
      window.onclick = function(event) {
        if (event.target == popup) {
            popup.classList.remove('show');
        }
      }
    }

    const form = document.getElementById('ContactFooter');
    if(form != null){
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            const formData = new FormData(form);
            $('.footer-block__newsletter').addClass('form-submitting');
        
            fetch(form.action, {
              method: 'POST',
              body: formData,
              headers: {
                'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.text())
            .then(data => {
                const html = new DOMParser().parseFromString(data, 'text/html');
                if(html.querySelector('.newsletter-form__message--success') != null){
                    $('h2.footer-block__heading').text("You've entered the dispensary.");
                }else{
                    $('h2.footer-block__heading').text('An error occurred. Please try again.');
                }
      
                setTimeout(function(){
                    $('h2.footer-block__heading').text("Get notifidied of new innovations:");
                    $('.footer-block__newsletter').removeClass('form-submitting');
                    $('.footer-block__newsletter').find('input').val('');
                }, 3000)
            })
            .catch(error => {
                const htmln = new DOMParser().parseFromString(error, 'text/html');
                if(htmln.querySelector('.newsletter-form__message--success') != null){
                    $('h2.footer-block__heading').text("You've entered the dispensary.");
                }else{
                    $('h2.footer-block__heading').text('An error occurred. Please try again.');
                }
      
                setTimeout(function(){
                    $('h2.footer-block__heading').text("Get notifidied of new innovations:");
                    $('.footer-block__newsletter').removeClass('form-submitting');
                    $('.footer-block__newsletter').find('input').val('');
                }, 3000)
            });
        });
    }

    if(location.href.indexOf('?collection-atc') != -1){
        $('.product-form__buttons button.product-form__submit').click();
        window.history.replaceState({ }, '', window.location.pathname);
    }

    // $('h1.header__heading img').css('visibility', 'visible')
})

window.addEventListener('load', function() {
    if($('body').hasClass('template-index')){
        $('.slider-home-slider').slick({
            infinite: true,
            autoplay: true,
            pauseOnHover:false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            speed: 1000,
            arrows: false,
            fade:true
        });
    }
})

$(document).on('click', '#ingredients-popup', function (e){
    e.preventDefault();
    $('body').css('overflow', 'hidden');
    $('div#shopify-section-header').css('opacity', 0);
    $(document).find('.media-atc-main.is-fixed-mobile').css('opacity', 0);
    $('div#product-ingredients-popup').addClass('show');
})

$(document).on( 'click', '.popup-content button[type=submit]', function (){
    fbq('track', 'CompleteRegistration');
})

$(document).on( 'click', '.CgOOSForms button[type=submit]', function (){
    fbq('track', 'CompleteRegistration');
})

if(window.innerWidth < 768){
  // $('.new-banner-home-main .new-banner-home-inner').css('height', window.innerHeight);
  $('.hero-banner.mobile-banner').css('height', window.innerHeight);
  $('.slider-home-slide picture').css('height', window.innerHeight);
  $('.media-atc-inner').addClass("fixed-mobile");
}

$(window).scroll(function() {
  if($(document).find('.fixed-atc-enable').length > 0){
      if(!$('.product-form__submit').hasClass('hideImp')){
        if(window.innerWidth >= 768){
            if ($('.shipping-notice-block').offset().top+50 < $(window).scrollTop()){
              $('.media-atc-main').addClass("is-fixed");
              $('.header__icons .language-selector-header').addClass("is-fixed");
              $('.shipping-notice-block').addClass("is-fixed-mobile");
            }else{
              $('.media-atc-main').removeClass("is-fixed");
              $('.language-selector-header').removeClass("is-fixed");
              $('.shipping-notice-block').removeClass("is-fixed-mobile");
            }
        }
      }else{
          $('.media-atc-main').removeClass("is-fixed");
          $('.media-atc-main').removeClass("is-fixed-mobile");
          $('.shipping-notice-block').removeClass("is-fixed-mobile");
      }

      if(window.innerWidth <= 768){
          if($('#shopify-section-footer').offset().top-window.innerHeight > $(window).scrollTop()){
              $('.media-atc-inner').addClass("fixed-mobile");
              $('.media-atc-inner').removeClass("no-fixed");
          }else{
              $('.media-atc-inner').addClass("no-fixed");
          }
      }
  }

  if ($('body').find('.product-section').length>0) {
      let lastScrollTop = 0,
        sticky = $('div#shopify-section-header'),
        scroll = $(window).scrollTop(),
        reviews = $('[id="shopify-block-loox-product-reviews"]'),
        show_on_this = 100;
    
      // if (reviews.length > 0) {
      //     show_on_this = reviews.offset().top;
      // }
    // alert(show_on_this)
      if (scroll >= show_on_this) {
          sticky.addClass('fixed afterfixed upscroll');
          sticky.find('.header-wrapper').slideDown()
          $('body').addClass('headFxed');
      } else {
          sticky.removeClass('fixed afterfixed upscroll');
          sticky.find('.header-wrapper').removeAttr('style')
          $('body').removeClass('headFxed');
      }
  }
});
